var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    viewBox: "0 0 100 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 86.5V67.5L88.5 60.5H74.5L70 54L69 44.5L74.5 36.5V27.5V18.5L69 9.5L62.5 4.5L54.5 2.5L46.5 1L36.5 4.5L27.7075 11.2736L24 18.5L23 27.5L24 36.5L28.5 45.5V54L25.5 60.5H14.5L1 67.5V86.5",
    stroke: "#EDEDED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.0e7d4488ccde1927623a94777d5e8922.svg";
export { ForwardRef as ReactComponent };